<div class="tpl3pl-page-container">
	<p class="text-muted mb-3 small">Send your product catalog to the 3PL so they know your SKUs. Choose which products in <strong>Configuration</strong> (Products to push to 3PL), then run Push below. Runs in background; refresh to see progress.</p>
	<div class="row mb-3 align-items-center">
		<div class="col-md-4">
			<div class="card text-center" matTooltip="Products in scope to push (from Configuration).">
				<div class="card-body py-3">
					<div class="text-muted small">Products to push</div>
					<div class="h4 mb-0">{{ catalogItems }}</div>
				</div>
			</div>
		</div>
		<div class="col-md-8 d-flex flex-wrap align-items-center gap-2">
			<button mat-raised-button color="primary" (click)="pushSkusToPgs()" [disabled]="skuPushing">
				<mat-icon>cloud_upload</mat-icon> {{ skuPushing ? 'Pushing...' : 'Push products to PGS' }}
			</button>
			<button mat-stroked-button (click)="openManualPushRaw()" matTooltip="Push one-by-one and see each response">
				<mat-icon>code</mat-icon>
				Manual push (raw)
			</button>
		</div>
	</div>

	<div *ngIf="skuPushing || skuDone" class="mb-3">
		<div class="card">
			<div class="card-body py-3">
				<div class="d-flex justify-content-between align-items-center mb-2">
					<strong>{{ skuPhase === 'remove' ? 'Removing from PGS' : 'Pushing to PGS' }}</strong>
					<div class="d-flex align-items-center gap-2">
						<span class="small text-muted">{{ skuProgress }} / {{ skuTotal }}</span>
						<button *ngIf="skuDone" mat-stroked-button (click)="loadSkuSyncStatus()">Refresh status</button>
						<button *ngIf="skuPushing" mat-stroked-button color="warn" (click)="cancelSkuPush()">Stop polling</button>
					</div>
				</div>
				<div class="progress product-master-progress-bar">
					<div class="progress-bar"
						[ngClass]="{'bg-success': skuDone && skuFailed === 0, 'bg-warning': skuDone && skuFailed > 0, 'progress-bar-striped progress-bar-animated': skuPushing}"
						role="progressbar"
						[style.width.%]="skuProgressPercent">
						{{ skuProgressPercent }}%
					</div>
				</div>
				<div class="d-flex mt-2 flex-wrap gap-2 small">
					<span class="text-success" *ngIf="skuCreated > 0">{{ skuCreated }} created</span>
					<span class="text-info" *ngIf="skuUpdated > 0">{{ skuUpdated }} updated</span>
					<span class="text-warning" *ngIf="skuDeleted > 0">{{ skuDeleted }} removed</span>
					<span class="text-danger" *ngIf="skuFailed > 0">{{ skuFailed }} failed</span>
					<span class="text-muted" *ngIf="skuDone && !skuCancelled">Complete</span>
					<span class="text-warning" *ngIf="skuDone && skuCancelled">Cancelled</span>
				</div>
				<div *ngIf="skuErrors.length > 0 && skuDone" class="mt-2">
					<details open>
						<summary class="small text-danger">{{ skuErrors.length }} error(s)</summary>
						<div class="small mt-1 product-master-errors-list">
							<div *ngFor="let e of skuErrors" class="mb-2 p-2 border border-danger rounded">
								<div class="text-danger font-weight-bold">{{ e.stockid }}: {{ e.message }}</div>
								<div *ngIf="e.code" class="text-muted">HTTP {{ e.code }}</div>
								<details *ngIf="e.response" class="mt-1">
									<summary class="small">PGS response</summary>
									<pre class="mb-0 p-2 bg-light small mt-1">{{ e.response | json }}</pre>
								</details>
							</div>
						</div>
					</details>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="loading" class="text-center py-2">
		<mat-spinner diameter="32"></mat-spinner>
	</div>
</div>
